// Конфигурация для каждого варианта иконки
export const iconConfig = {
	sale: {
		iconPath: 'sale',
		ariaLabel: 'Скидка',
	},
	max_stroke: {
		iconPath: 'max_stroke',
		ariaLabel: 'MAX',
	},
	max: {
		iconPath: 'max',
		ariaLabel: 'MAX',
	},
	star: {
		iconPath: 'star',
		ariaLabel: 'Рейтинг',
	},
	link: {
		iconPath: 'link',
		ariaLabel: 'Ссылка',
	},
	paper_plane: {
		iconPath: 'paper_plane',
		ariaLabel: 'Отправить',
	},
	check_double: {
		iconPath: 'check_double',
		ariaLabel: 'Завершён',
	},
	circle_x: {
		iconPath: 'circle_x',
		ariaLabel: 'Отменён',
	},
	circle_arrow_right: {
		iconPath: 'circle_arrow_right',
		ariaLabel: 'Перейти',
	},
	lock_keyhole: {
		iconPath: 'lock_keyhole',
		ariaLabel: 'Закрыто',
	},
	fork_knife: {
		iconPath: 'fork_knife',
		ariaLabel: 'Еда и напитки',
	},
	arrow_left_long: {
		iconPath: 'arrow_left_long',
		ariaLabel: 'Назад',
	},
	chevrons_up: {
		iconPath: 'chevrons_up',
		ariaLabel: 'Свернуть',
	},
	chevrons_down: {
		iconPath: 'chevrons_down',
		ariaLabel: 'Развернуть',
	},
	user_pen: {
		iconPath: 'user_pen',
		ariaLabel: 'Процент',
	},
	percent: {
		iconPath: 'percent',
		ariaLabel: 'Процент',
	},
	calendar: {
		iconPath: 'calendar',
		ariaLabel: 'Календарь',
	},
	eye: {
		iconPath: 'eye',
		ariaLabel: 'Просмотры',
	},
	thin_instagram: {
		iconPath: 'thin_instagram',
		ariaLabel: 'Instagram',
	},
	instagram: {
		iconPath: 'instagram',
		ariaLabel: 'Instagram',
	},
	circle_info: {
		iconPath: 'circle_info',
		ariaLabel: 'Информация',
	},
	thin_globe: {
		iconPath: 'thin_globe',
		ariaLabel: 'Веб-сайт',
	},
	globe: {
		iconPath: 'globe',
		ariaLabel: 'Веб-сайт',
	},
	caret_down: {
		iconPath: 'caret_down',
		ariaLabel: 'Развернуть',
	},
	bars: {
		iconPath: 'bars',
		ariaLabel: 'Барс',
	},
	chevron_left: {
		iconPath: 'chevron_left',
		ariaLabel: 'Влево',
	},
	chevron_right: {
		iconPath: 'chevron_right',
		ariaLabel: 'Вправо',
	},
	loveseat: {
		iconPath: 'loveseat',
		ariaLabel: 'Диван',
	},
	mug_hot: {
		iconPath: 'mug_hot',
		ariaLabel: 'Кружка',
	},
	wifi: {
		iconPath: 'wifi',
		ariaLabel: 'Wi-Fi',
	},
	shirt: {
		iconPath: 'shirt',
		ariaLabel: 'Рубашка',
	},
	door_open: {
		iconPath: 'door_open',
		ariaLabel: 'Дверь открыта',
	},

	arrow_right_long: {
		iconPath: 'arrow_right_long',
		ariaLabel: 'Стрелка вправо',
	},
	minus: {
		iconPath: 'minus',
		ariaLabel: 'Минус',
	},
	check: {
		iconPath: 'check',
		ariaLabel: 'Галочка',
	},
	floppy_disk: {
		iconPath: 'floppy_disk',
		ariaLabel: 'Сохранить',
	},
	folder_open: {
		iconPath: 'folder_open',
		ariaLabel: 'Папка открыта',
	},
	copy: {
		iconPath: 'copy',
		ariaLabel: 'Копировать',
	},
	grip_dots: {
		iconPath: 'grip_dots',
		ariaLabel: 'Точки',
	},
	upload: {
		iconPath: 'upload',
		ariaLabel: 'Загрузить',
	},
	trash: {
		iconPath: 'trash',
		ariaLabel: 'Корзина',
	},
	pen_to_square: {
		iconPath: 'pen_to_square',
		ariaLabel: 'Редактировать',
	},
	gears: {
		iconPath: 'gears',
		ariaLabel: 'Шестеренки',
	},
	headset: {
		iconPath: 'headset',
		ariaLabel: 'Наушники',
	},
	images: {
		iconPath: 'images',
		ariaLabel: 'Изображения',
	},
	users: {
		iconPath: 'users',
		ariaLabel: 'Пользователи',
	},
	user_plus: {
		iconPath: 'user_plus',
		ariaLabel: 'Добавить пользователя',
	},
	chart_waterfall: {
		iconPath: 'chart_waterfall',
		ariaLabel: 'Диаграмма',
	},
	shop: {
		iconPath: 'shop',
		ariaLabel: 'Магазин',
	},
	list: {
		iconPath: 'list',
		ariaLabel: 'Список',
	},
	power_off: {
		iconPath: 'power_off',
		ariaLabel: 'Выключить',
	},
	lock: {
		iconPath: 'lock',
		ariaLabel: 'Замок',
	},
	gear: {
		iconPath: 'gear',
		ariaLabel: 'Настройки',
	},
	plus: {
		iconPath: 'plus',
		ariaLabel: 'Плюс',
	},
	user: {
		iconPath: 'user',
		ariaLabel: 'Пользователь',
	},
	thin_telegram: {
		iconPath: 'thin_telegram',
		ariaLabel: 'Телеграм',
	},
	telegram_only_icon: {
		iconPath: 'telegram_only_icon',
		ariaLabel: 'Telegram',
	},
	vk_only_icon: {
		iconPath: 'vk_only_icon',
		ariaLabel: 'ВК',
	},
	telegram: {
		iconPath: 'telegram',
		ariaLabel: 'Telegram',
	},
	vk: {
		iconPath: 'vk',
		ariaLabel: 'ВК',
	},
	xmark: {
		iconPath: 'xmark',
		ariaLabel: 'Закрыть',
	},
	magnifying_glass: {
		iconPath: 'magnifying_glass',
		ariaLabel: 'Поиск',
	},
	thin_location_dot: {
		iconPath: 'thin_location_dot',
		ariaLabel: 'Зал',
	},
	location_dot: {
		iconPath: 'location_dot',
		ariaLabel: 'Зал',
	},
	train_subway_tunnel: {
		iconPath: 'train_subway_tunnel',
		ariaLabel: 'Метро',
	},
	square_parking: {
		iconPath: 'square_parking',
		ariaLabel: 'Парковка',
	},
	bottle_water: {
		iconPath: 'bottle_water',
		ariaLabel: 'Вода',
	},
	clock: {
		iconPath: 'clock',
		ariaLabel: 'Часы',
	},
	heart_red: {
		iconPath: 'heart_red',
		ariaLabel: 'Сердце красное',
	},
	heart: {
		iconPath: 'heart',
		ariaLabel: 'Сердце',
	},
	thin_phone: {
		iconPath: 'thin_phone',
		ariaLabel: 'Телефон',
	},
	phone: {
		iconPath: 'phone',
		ariaLabel: 'Телефон',
	},
	arrow_down_big_small: {
		iconPath: 'arrow_down_big_small',
		ariaLabel: 'Сортировка',
	},
	metro: {
		iconPath: 'metro',
		ariaLabel: 'Метро',
	},
	telegram_gray: {
		iconPath: 'telegram_gray',
		ariaLabel: 'Telegram',
	},
	vk_gray: {
		iconPath: 'vk_gray',
		ariaLabel: 'ВК',
	},
	filter_list: {
		iconPath: 'filter_list',
		ariaLabel: 'Фильтр',
	},
	edit: {
		iconPath: 'icon_edit',
		ariaLabel: 'Редактировать',
	},
	add: {
		iconPath: 'icon_add',
		ariaLabel: 'Добавить',
	},
}
